import React from 'react';
import QuestionSingleSelector from '../components/QuestionSingleSelector';
import {SingleSelectorQuestion} from '../types/question';

const QuestionThreeVehicleUse = (props: SingleSelectorQuestion) => {
  const {title, singleSelectOptions, subHeading} = props;
  return (
    <QuestionSingleSelector
      title={title || ''}
      singleSelectOptions={singleSelectOptions}
      subHeading={subHeading ?? ''}
    />
  );
};

export default QuestionThreeVehicleUse;
